var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"search-language",attrs:{"for":_vm.label}},[_c('input',{staticClass:"search-language__checkbox",attrs:{"id":_vm.label,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){_vm.addToQuery({ name: _vm.name, path: _vm.path })}}}),_vm._v(" "),_c('label',{staticClass:"search-language__checkbox-indicator",attrs:{"for":_vm.label}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e422588","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchLanguage.vue
// module id = 681
// module chunks = 1